module.exports = __webpack_public_path__ + "static/media/logo-icon.b5455893.svg";